import { render, staticRenderFns } from "./main-tab.vue?vue&type=template&id=3d688cb8&scoped=true"
import script from "./main-tab.vue?vue&type=script&lang=js"
export * from "./main-tab.vue?vue&type=script&lang=js"
import style0 from "./main-tab.vue?vue&type=style&index=0&id=3d688cb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d688cb8",
  null
  
)

export default component.exports